// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__xh8nt","sectionTitle":"Dashboard_sectionTitle__iomFW","card":"Dashboard_card__LuexR","cardTitle":"Dashboard_cardTitle__ML2BT"};